import React from 'react';
import PropTypes from 'prop-types';

export default function ExperimentOriginal({ activeVariant, children }) {
  return (
    <>
      {activeVariant === '0' || activeVariant === null ? children : null}
    </>
  );
}

ExperimentOriginal.propTypes = {
  activeVariant: PropTypes.string,
  children: PropTypes.node,
};

ExperimentOriginal.defaultProps = {
  activeVariant: '0',
  children: null,
};
